import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'hms'})
export class HmsPipe implements PipeTransform {

  transform(value: any, args?: any): string {
    const num = Number(value);
    if (isNaN(num)) {
      return value.toString();
    }
    if (num < 1000) {
      return '0:00';
    }
    const numInSecs = num / 1000;
    const seconds = Math.floor(numInSecs % 60);
    let secondsToShow = seconds.toString();
    if (seconds < 10) {
      secondsToShow = '0' + secondsToShow;
    }
    const minutes = Math.floor(numInSecs / 60);
    return '' + minutes + ':' + secondsToShow;
  }
}



// WEBPACK FOOTER //
// /Users/tabelini/development/jvm/tenacity/pysix/PysixCloud/src/app/hms.pipe.ts